import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../auth/AuthContext';
import {
  FaHome,
  FaTools,
  FaBox,
  FaShoppingCart,
  FaBolt,
  FaRupeeSign,
  FaCog,
  FaClipboardList,
  FaProjectDiagram,
  FaTimes,
  FaSignOutAlt
} from 'react-icons/fa';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    { id: 'overview', label: 'Overview', icon: FaHome, path: '/garage/dashboard' },
    { id: 'jobs', label: 'Jobs', icon: FaTools, path: '/garage/dashboard/jobs' },
    { id: 'inventory', label: 'Inventory', icon: FaBox, path: '/garage/dashboard/inventory' },
    { id: 'orders', label: 'Orders', icon: FaShoppingCart, path: '/garage/dashboard/orders' },
    { id: 'deals', label: 'Deals', icon: FaBolt, path: '/garage/dashboard/deals' },
    { id: 'quotes', label: 'Quotes', icon: FaClipboardList, path: '/garage/dashboard/quotes' },
    { id: 'projects', label: 'Projects', icon: FaProjectDiagram, path: '/garage/dashboard/projects' },
    { id: 'earnings', label: 'Earnings', icon: FaRupeeSign, path: '/garage/dashboard/earnings' },
    { id: 'settings', label: 'Settings', icon: FaCog, path: '/garage/dashboard/settings' },
  ];

  const isActive = (path) => {
    if (path === '/garage/dashboard') {
      return location.pathname === '/garage/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-full bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'
          } lg:translate-x-0 lg:sticky lg:top-0 lg:h-screen w-64 border-r border-gray-200 shrink-0`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-900">Garage</h2>
            <button
              onClick={() => setIsOpen(false)}
              className="lg:hidden text-gray-600 hover:text-gray-900"
            >
              <FaTimes />
            </button>
          </div>

          <nav className="flex-1 overflow-y-auto p-4">
            <ul className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const active = isActive(item.path);
                return (
                  <li key={item.id}>
                    <button
                      onClick={() => {
                        navigate(item.path);
                        setIsOpen(false);
                      }}
                      className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${active
                          ? 'bg-blue-50 text-blue-600 font-semibold'
                          : 'text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                      <Icon className="text-lg" />
                      <span>{item.label}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>

          <div className="p-4 border-t border-gray-200 space-y-2">
            <button
              onClick={() => { navigate('/'); }}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <FaHome className="text-lg" />
              <span>Back to Home</span>
            </button>
            <button
              onClick={() => { logout(); navigate('/'); }}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
            >
              <FaSignOutAlt className="text-lg" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;

